import React, { useContext } from 'react';
import { compose, path, prop } from 'ramda';
import { pure, withProps } from 'recompose';
import { Game as CommonGame } from 'js/components/common/Game';
import { DemoButton, PlayButton } from 'js/components/common/Game/Buttons';
import { useAppSelector, useDeviceSelector } from 'js/store/hooks';
import { StatusBadge } from '../../common/StartStatusBadge';
import { RACE_RULE_STATUSES } from '../../constants';
import { CategoryContext } from '../context';
import style from './index.scss';

export const GameStatusBadge = withProps(
    ({ status: ruleStatus }) => ({
            status: ruleStatus === RACE_RULE_STATUSES.approved ? 'notStarted' : ruleStatus.toLowerCase(),
            tKeyPrefix: 'gameItem.status'
        })
)(StatusBadge);

export const HoveredGame = ({ code, name, showDemoButton }) => (
    <div className={style.hovered}>
        <div className={style.title}>{name}</div>
        <div className={style.buttons}>
            {showDemoButton && <DemoButton code={code} name={name} isHoverBtn={true} />}
            <PlayButton code={code} name={name} isHoverBtn={true} />
        </div>
    </div>
);

export const Game = ({ status, code, className, isDesktop, setGameRef, ...rest }) => (
    <div className={style.game} ref={setGameRef}>
        <CommonGame {...{
            code,
            className,
            showTitle: false,
            showRecentlyPlayedIcon: false,
            showFavoriteIcon: false,
            showFeatureIcons: false,
            showGameInfo: true,
            size: 'medium'
        }} />
        <GameStatusBadge className={style.badge} status={status} />
        {isDesktop && <HoveredGame code={code} {...rest} />}
    </div>
);

export default compose(
    pure,
    withProps(
        ({ code }) => {
            const isDesktop = useDeviceSelector(prop('isDesktop'));
            const { name, funSupport } = useAppSelector(path(['games', code]));
            const enableDemoMode = useAppSelector(path(['leaderboard', 'enableDemoMode']));
            const { status = '' } = useContext(CategoryContext);
            const className = [
                isDesktop ? style.gameInner : '',
                status === RACE_RULE_STATUSES.approved && style.monochrome
            ].filter(Boolean).join(' ');

            return {
                name,
                status,
                className,
                isDesktop,
                showDemoButton: !(funSupport === 'unavailable' || funSupport === 'guest') && enableDemoMode
            };
        }
    )
)(Game);
